import request from '@/utils/request'

// 获取当前进行中的拼团活动信息
export function getActiveInfo(params) {
  return request({
    url: '/client/gw/api/v1/activity',
    method: 'get',
    params
  })
}

// 获取用户拼团信息
export function getUserActiveInfo(params) {
  return request({
    url: '/client/gw/api/v1/user_activity',
    method: 'get',
    params
  })
}

// 参与拼团
export function join(data) {
  return request({
    url: '/client/gw/api/v1/join_activity',
    method: 'post',
    data
  })
}

// 获取用户拼团信息
export function getUserActiveInfoWX(params) {
  return request({
    url: '/client/gw/api/v1/user_activity',
    method: 'get',
    params,
    headers: {
      TokenType: 'official'
    }
  })
}
// 参与拼团
export function joinWX(data) {
  return request({
    url: '/client/gw/api/v1/join_activity',
    method: 'post',
    data,
    headers: {
      TokenType: 'official'
    }
  })
}